import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appAutoFitText]',
  standalone: true
})
export class AutoFitTextDirective {
  private element: HTMLElement;

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.element = el.nativeElement;
  }

  @HostListener('window:resize')
  onResize() {
    this.fitText();
  }

  ngAfterViewInit() {
    setTimeout(() => this.fitText(), 50)
  }

  private fitText() {
    if (this.element.parentElement) {
      const containerWidth = this.element.parentElement.clientWidth - 100;
      let fontSize = 10; // Initial font size
      this.renderer.setStyle(this.element, 'fontSize', `${fontSize}px`);
      this.renderer.setStyle(this.element.parentElement, 'fontSize', `${fontSize}px`);

      // Increase font size until the text exceeds the container's width
      while (this.element.clientWidth < containerWidth && fontSize < 200) {
        fontSize += 1;
        this.renderer.setStyle(this.element, 'fontSize', `${fontSize}px`);
        this.renderer.setStyle(this.element.parentElement, 'fontSize', `${fontSize}px`);
      }

      // Decrease font size until the text fits within the container's width
      while (this.element.clientWidth > containerWidth && fontSize > 1) {
        fontSize -= 1;
        this.renderer.setStyle(this.element, 'fontSize', `${fontSize}px`);
        this.renderer.setStyle(this.element.parentElement, 'fontSize', `${fontSize}px`);
      }
    }
  }
}
